import React, { Component } from 'react';
import ReactMarkdown from 'react-markdown';
import DocIntegrationSections from './DocIntegrationSections';
import remarkGfm from 'remark-gfm'
import HelperEnv from '../../helpers/HelperEnv';
import '../../style/integration.css'
import HelperGenerics from '../../helpers/HelperGenerics';

class DocIntegrationMain extends Component {

    constructor(props) {
        super(props)
        this.state = { headings: [], headingsHash: {} }
    }

    headingsHash = [];
    currH1Key = null;

    render() {
        return (
            <React.Fragment>
                {HelperEnv.isEnableDoc() === 'true' && <div className="modal" tabIndex="-1" id={this.props.id}>
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header border-0" >
                                <div className="container-fluid">
                                    <button type="button" className="btn-close float-end" data-bs-dismiss="modal" aria-label="Close" onMouseDown={(e) => e.currentTarget.blur()}></button>
                                </div>
                            </div>
                            <div className="modal-body text-start docintegration">
                                <div className="row">
                                    <div className="col col-lg-4 col-12 order-2" >
                                        <div className="position-fixed">
                                            <DocIntegrationSections sections={this.state.headings} />
                                        </div>
                                    </div>
                                    <div className="col col-lg-8 col-12 order-1 overflow:scroll">
                                        <ReactMarkdown children={this.props.textDocInteg} remarkPlugins={[remarkGfm]}
                                            components={{
                                                h1: ({ children, ...props }) => {
                                                    if (children != null && children.length > 0) {
                                                        const key = children[0].toString('base64');
                                                        this.currH1Key = key;
                                                        if (this.headingsHash[key] == null) {
                                                            this.state.headings.push({ key: key, text: children, level: 1, children: [] });
                                                            this.headingsHash[key] = key;
                                                        }
                                                        return (<h1 {...props} id={HelperGenerics.rebuildAnchor(key)}>{children}</h1>)
                                                    }
                                                    return (<h1 {...props} >{children}</h1>)
                                                },
                                                h2: ({ children, ...props }) => {
                                                    if (children != null && children.length > 0) {
                                                        const key = children[0].toString('base64');
                                                        if (this.currH1Key != null && this.headingsHash[this.currH1Key] != null && this.headingsHash[key] == null) {
                                                            this.state.headings.forEach(elt => {
                                                                if (elt.key === this.currH1Key) {
                                                                    elt.children.push({ key: key, text: children, level: 2 });
                                                                }
                                                            });
                                                            this.headingsHash[key] = key;
                                                        }
                                                        return (<h2 {...props} id={HelperGenerics.rebuildAnchor(key)}>{children}</h2>)
                                                    }
                                                    return (<h2 {...props} >{children}</h2>)
                                                },
                                                a: ({ children, ...props }) => {
                                                    if (props.href.startsWith('http')) {
                                                        props.target = '_blank';
                                                        props.rel = 'noopener noreferrer'
                                                    }
                                                    props = { ...props, node: undefined };
                                                    return (<a {...props} >{children}</a>)
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            </React.Fragment>
        )
    }
}

export default (DocIntegrationMain);
